/*
 * @Author: panweikang
 * @Date: 2024-01-04 15:23:35
 * @LastEditTime: 2024-07-24 18:25:02
 * @Description:
 */
import './pay.scss'
import React, { useEffect, useState } from 'react'
import logo from '../../static/report/logo.png'
import tiefenActivePng from '../../static/pay/tiefen_active.png'
import tiefenPng from '../../static/pay/tiefen.png'
import lightPng from '../../static/pay/light.png'
import boughtPng from '../../static/pay/bought.png'
import bought2Png from '../../static/pay/bought2.png'
import tips1Png from '../../static/pay/tips1.png'

import { Avatar, Image, Button, Toast } from 'antd-mobile'

import { regionImage, regionDes } from './constants'
import {
  getSharePayDetailApi,
  getRegionListApi,
  wxJsapiPayApi,
  jsConfigApi,
} from '../../api/yearEndReportApi'

import clonedeep from 'lodash.clonedeep'
import Decimal from 'decimal.js'
import { useMemo } from 'react'

import { useNavigate } from 'react-router-dom'
import wxConfig from '../../utils/wxConfig'

// import MShare from '../../components/MShare/index'

import MHead from '../../components/MHead/index'

// step
let MStepper = ({ disable, onChange }) => {
  let [count, setCount] = useState(0)

  useEffect(() => {
    onChange(count)
  }, [count])

  let minus = () => {
    if (disable || count === 0) {
      return
    }
    setCount(count - 1)
  }
  let add = () => {
    if (disable || count === 1) {
      return
    }
    setCount(count + 1)
  }

  return (
    <div className="MStepper">
      <svg
        onClick={minus}
        t="1704436791771"
        className="icon-minus"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="5514"
        width="18"
        height="18"
      >
        <path
          d="M533.333333 85.333333c-247.426667 0-448 200.573333-448 448s200.573333 448 448 448 448-200.573333 448-448-200.573333-448-448-448z m0 853.333334c-223.86 0-405.333333-181.473333-405.333333-405.333334s181.473333-405.333333 405.333333-405.333333 405.333333 181.473333 405.333334 405.333333-181.473333 405.333333-405.333334 405.333334z m234.666667-405.333334a21.333333 21.333333 0 0 1-21.333333 21.333334H320a21.333333 21.333333 0 0 1 0-42.666667h426.666667a21.333333 21.333333 0 0 1 21.333333 21.333333z"
          fill="#5C5C66"
          p-id="5515"
        ></path>
      </svg>
      <p>{count}</p>
      <svg
        onClick={add}
        t="1704436595792"
        className="icon-add"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="4542"
        width="18"
        height="18"
      >
        <path
          d="M511.488 64.468c-246.974 0-447.184 200.211-447.184 447.185 0 246.972 200.21 447.185 447.184 447.185s447.185-200.213 447.185-447.185c0-246.974-200.21-447.185-447.185-447.185z m223.795 472.027h-198.95v198.953c0 13.608-11.028 24.64-24.846 24.64-13.72 0-24.845-11.311-24.845-24.64V536.495h-198.95c-13.607 0-24.64-11.027-24.64-24.842 0-13.722 11.31-24.845 24.64-24.845h198.953V287.856c0-13.608 11.027-24.64 24.844-24.64 13.72 0 24.845 11.311 24.845 24.64v198.953h198.95c13.611 0 24.643 11.027 24.643 24.845-0.002 13.719-11.313 24.84-24.644 24.84z"
          p-id="4543"
          fill="#18378A"
        ></path>
      </svg>
    </div>
  )
}

let Pay = () => {
  // document.title = '分享/付费'
  document.title = '瑞莱博2023年物流地产年度报告'
  let navigate = useNavigate()

  let userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}')
  let [isSubscribe, setIsSubscribe] = useState(0)
  let [products, setProducts] = useState([])

  let [originalPriceAll, setOriginalPriceAll] = useState(0)
  let [fanPriceAll, setFanPriceAll] = useState(0)

  let rounding2 = (num) => {
    return Math.floor(num * 100) / 100
  }

  useEffect(() => {
    // wxConfig()
    init()
  }, [])

  let init = async () => {
    let res = await getRegionListApi({
      year: '2023-H2',
    })

    let res1 = await getSharePayDetailApi({
      openId: userInfo.openId,
      year: '2023-H2',
    })

    setIsSubscribe(res1.data.userInfo.isSubscribe)

    let unLockProducts = []
    res1.data.unLockProducts.forEach((item) => {
      item.topics.forEach((it) => {
        unLockProducts.push(it.topicId)
      })
    })

    res.data.forEach((item) => {
      let unlockNum = 0
      item.topics.forEach((it) => {
        it.unlock = unLockProducts.includes(it.topicId)
        if (it.unlock) {
          unlockNum = unlockNum + 1
        }
      })

      item.originalPrice =
        3 - unlockNum === 3
          ? item.originalPrice
          : rounding2(rounding2((item.originalPrice * 100) / 3 / 100) * (3 - unlockNum))

      item.fanPrice =
        3 - unlockNum === 3
          ? item.fanPrice
          : rounding2(rounding2((item.fanPrice * 100) / 3 / 100) * (3 - unlockNum))

      item.count = 0
    })
    console.log(res.data)
    setProducts(res.data)
  }

  let onCountChange = (region, count) => {
    setProducts((current) => {
      current.forEach((item) => {
        if (item.regionId === region.regionId) {
          item.count = count
        }
      })

      return clonedeep(current)
    })
  }

  useEffect(() => {
    if (products && products.length > 0) {
      let originalPriceAll = 0
      let fanPriceAll = 0
      products.forEach((item) => {
        if (item.count > 0) {
          originalPriceAll = new Decimal(originalPriceAll).plus(item.originalPrice).toString()
          fanPriceAll = new Decimal(fanPriceAll).plus(item.fanPrice).toString()
        }
      })

      setOriginalPriceAll(originalPriceAll)
      setFanPriceAll(fanPriceAll)
    }
  }, [products])

  let productIds = useMemo(() => {
    let p = []
    products.forEach((item) => {
      if (item.count > 0) {
        p.push(item.regionId)
      }
    })
    return p
  }, [products])

  let payParams = {}

  let payFn = async () => {
    if (!(productIds && productIds.length > 0)) {
      return Toast.show('还没选择购买的报告~')
    }
    let res = await wxJsapiPayApi({
      'openId': userInfo.openId,
      'productIds': productIds,
      'price': isSubscribe === 1 ? fanPriceAll : originalPriceAll,
      // 'price': 0.01,
    })
    if (res.status === 200) {
      payParams = {
        'appId': res.data.appId,
        'timeStamp': res.data.timeStamp,
        'nonceStr': res.data.nonceStr,
        'package': res.data.packAge,
        'signType': res.data.signType,
        'paySign': res.data.paySign,
      }
      console.log('payParams', payParams)
      wxPay()
    } else {
      Toast.show(res.msg)
    }
  }

  function onBridgeReady() {
    console.log(payParams)
    // eslint-disable-next-line no-undef
    WeixinJSBridge.invoke(
      'getBrandWCPayRequest',
      {
        ...payParams,
      },
      function (res) {
        console.log('getBrandWCPayRequest', res)
        if (res.err_msg === 'get_brand_wcpay_request:ok') {
          navigate('/rlb/YearEndReport/bought')
        }
      }
    )
  }

  function wxPay() {
    if (typeof WeixinJSBridge == 'undefined') {
      if (document.addEventListener) {
        document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false)
      } else if (document.attachEvent) {
        document.attachEvent('WeixinJSBridgeReady', onBridgeReady)
        document.attachEvent('onWeixinJSBridgeReady', onBridgeReady)
      }
    } else {
      onBridgeReady()
    }
  }
  let [shareVisible, setShareVisible] = useState(false)
  let shareFn = async () => {
    // setShareVisible(true)
    navigate(`/rlb/YearEndReport/share`)
  }

  let goHome = () => {
    navigate(`/rlb/YearMiddleReport2024/1`)
  }

  let goFW = () => {
    window.location.href =
      'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzAwMjc4OTg2Mg==#wechat_redirect'
  }

  return (
    <div className="pay page">
      <MHead />
      <div className="pageContent">
        <div className="userInfo">
          <Avatar style={{ '--size': '32px' }} src={userInfo.headImgUrl} alt="avatar" />
          <p className="userName">{userInfo.nickName}</p>
          <Image
            src={isSubscribe === 1 ? tiefenActivePng : tiefenPng}
            width={81}
            height={24}
            fit="fill"
          />
          {isSubscribe === 0 && (
            <div className="guanzhuWrap" onClick={goFW}>
              <div className="guanzhuBtn">关注服务号</div>
              <div className="guanzhuTip">
                <Image src={lightPng} width={16} height={16} fit="fill" />
                <p>点亮铁粉标签</p>
              </div>
            </div>
          )}
        </div>
        <div className="tip">
          {isSubscribe === 1
            ? `已为尊贵的瑞莱博铁粉优惠${new Decimal(originalPriceAll)
              .minus(fanPriceAll)
              .toString()}元`
            : `成为尊贵的瑞莱博铁粉最高优惠40元`}
        </div>

        <div className="payList">
          {products.map((item) => {
            return (
              <div className="listItem" key={item.regionId}>
                <Image
                  className="image"
                  src={regionImage[item.regionId]}
                  width={105}
                  height={57}
                  fit="cover"
                />
                <div className="listItemRight">
                  <div className="listTitle">
                    <span>{item.regionName}</span>
                    <em>￥{isSubscribe === 1 ? item.fanPrice : item.originalPrice}</em>
                    {/* {item.originalPrice == 0 && } */}
                  </div>
                  {item.originalPrice == 0 ?
                    <img src={bought2Png} alt="bought2Png" className='boughtPng' />
                    : (
                      <div className="listTxt">
                        <div>
                          <p>
                            {item.topics
                              .filter((i) => !i.unlock)
                              .map((i) => i.topicName)
                              .join(' ')}
                          </p>
                          {/* <p>{regionDes[item.regionId]}</p> */}
                          <p>{item.topics.filter((i) => !i.unlock).length} / 3 待解锁</p>
                        </div>
                        <MStepper
                          disable={item.originalPrice == 0}
                          onChange={(count) => {
                            onCountChange(item, count)
                          }}
                        />
                      </div>
                    )}
                </div>
              </div>
            )
          })}
        </div>

        <div className="price">
          <p className="priceItem">
            报告总价 ￥ <span>{isSubscribe === 1 ? fanPriceAll : originalPriceAll}</span>
          </p>
          {isSubscribe === 1 ? (
            <p className="priceItem originalPrice">原价 ￥ {originalPriceAll}</p>
          ) : (
            <p className="priceItem">铁粉价 ￥ {fanPriceAll}</p>
          )}
        </div>

        <div className="pageFooter">
          {/*
            <Button className="btn" color="primary" fill="outline" onClick={shareFn}>
            集报告锦囊 免费解锁
          </Button>
            */}

          <Button className="btn" color="primary" onClick={payFn}>
            去支付
          </Button>
        </div>
        <Image src={tips1Png} fit="fill" width="100%" />
      </div>
      {/* <MShare
        visible={shareVisible}
        onClose={() => {
          setShareVisible(false)
        }}
      /> */}
    </div>
  )
}

export default Pay
